import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

const PopularCategories = () => {
  const [hoveredSlideId, setHoveredSlideId] = useState(null);
  const slides = [
    { id: 1, img_url: "/img/pop-categories/one.webp", name: "one" },
    { id: 2, img_url: "/img/pop-categories/one.webp", name: "two" },
    { id: 3, img_url: "/img/pop-categories/one.webp", name: "three" },
    { id: 4, img_url: "/img/pop-categories/one.webp", name: "four" },
    { id: 5, img_url: "/img/pop-categories/one.webp", name: "five" },
    { id: 6, img_url: "/img/pop-categories/one.webp", name: "six" },
    { id: 7, img_url: "/img/pop-categories/one.webp", name: "seven" },
    { id: 8, img_url: "/img/pop-categories/one.webp", name: "eight" },
  ];

  return (
    <div className="popular_categories">
      <div className="popular_categories_main container">
        <h1 className="dc-script text-center">Popular Caegories</h1>
        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 2500, disableOnInteraction: true }}
          loop={true}
          spaceBetween={50}
          slidesPerView={1}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
          }}
        >
          {slides.map((slide) => (
            <SwiperSlide
              key={slide.id}
              className={`categories_slide${slide.id} categories_slide flex-col-center`}
              onMouseOver={() => setHoveredSlideId(slide.id)}
              onMouseOut={() => setHoveredSlideId(null)}
            >
              <img
                className={
                  hoveredSlideId === slide.id
                    ? "animate__animated animate__jello"
                    : ""
                }
                src={slide.img_url}
                alt="category"
              />
              <span className="dc-script">{slide.name}</span>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default PopularCategories;
